const routes = {
  DASHBOARD: "/dashboard",
  CASE_COMPLETE: "/case_complete/:caseId",
  SUPERVISOR_DASHBOARD: "/supervisor_dashboard",
  REPORTS: {
    DASHBOARD: "/reports",
    QUEUE_VOLUME: "/reports/:queueId/volume",
    PRODUCTIVITY: "/productivity",
  },
  CYPRESS_LANDING: "/cypress/cypress_landing",
  USER_MANAGEMENT: "/user_management",
  WISER_DOWNLOAD: "/wiser_download",
  FIND_A_CASE: "/find_a_case",
};

export default routes;
